<template>
  <div v-if="!isLoading" class="tw:border-b tw:border-gray-300 tw:mb-6 tw:pb-4">
    <PropertyHotelConnectBadge :hasCampaign="hasCampaign" :status="status" />
    <div class="tw:mt-2 tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:items-center">
      <p class="tw:md:w-2/3 tw:leading-5" v-html="$t(hotelConnectInfo)" />
      <CheckPropertyLink source="propertyDetails" v-if="hasCampaign" />
      <MainButton v-if="!hasCampaign" @click="onUpdateClick" class="tw:md:mt-0 tw:mt-4 tw:w-full tw:md:w-auto">{{
        $t(hotelConnectButtonLabel)
      }}</MainButton>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import MainButton from '@/components/base/buttons/MainButton.vue'
import CheckPropertyLink from '@/components/dashboard/CheckPropertyLink.vue'
import PropertyHotelConnectBadge from '@/components/propertyDetails/propertyBasicInfo/PropertyHotelConnectBadge.vue'

import { useStudioPlusCampaign } from '@/components/payment/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useStudioPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useStudioPlusReactivation'

import appAnalytics from '@/utils/tracking'

const router = useRouter()
const { openReactivationModal } = useStudioPlusReactivation()
const { isLoading, isExpiredSubscription, isPlus, isPro } = useStudioPlusCampaign(selectedAccommodationId)
const hasCampaign = computed(() => (isPro.value || isPlus.value) && !isExpiredSubscription.value)

const hotelConnectButtonLabel = computed(() => {
  if (isExpiredSubscription.value && isPlus.value) return 'reactivate_subscription_cta'
  else return 'plus_upgrade_cta'
})
const hotelConnectInfo = computed(() => {
  if (hasCampaign.value) return 'contact_badge_live_info'
  else if (isExpiredSubscription.value && isPlus.value) return 'contact_badge_deactivated_info'
  else return 'hotel_connect_badge_upgrade'
})

const status = computed(() => {
  if (hasCampaign.value) return 'contact_badge_live'
  else if (isExpiredSubscription.value && isPlus.value) return 'contact_badge_deactivated'
  else return 'hotel_connect_badge_non_plus'
})
const onUpdateClick = () => {
  if (isExpiredSubscription.value && isPlus.value) {
    appAnalytics.track(appAnalytics.events.PD_HOTEL_CONNECT_REACTIVATE_BTN, {
      accommodationId: selectedAccommodationId.value,
    })

    openReactivationModal(selectedAccommodationId.value, 'property-details')
  } else {
    appAnalytics.track(appAnalytics.events.PD_HOTEL_CONNECT_UPDATE_BTN, {
      accommodationId: selectedAccommodationId.value,
    })
    router.push({ name: 'studio-plus-compare' })
  }
}
</script>
